// extracted by mini-css-extract-plugin
export default {"row":"Notification_row__JvZiR","col":"Notification_col__L7mRt"};